<template>
  <b-dropdown
    ariaRole="list"
    :disabled="disabled"
    :class="[
      $attrs.class,
      {
        '[&>.dropdown-menu>.dropdown-content>.is-active]:text-lighter-grey-4 [&>.dropdown-menu>.dropdown-content>.is-active]:bg-white-grey ':
          !isSelector,
        '[&>.dropdown-menu>.dropdown-content>.is-active]:text-lighter-grey-4 [&>.dropdown-menu>.dropdown-content>.is-active]:bg-white ':
          isSelector,
        '[&>.dropdown-menu>.dropdown-content]:relative [&>.dropdown-menu>.dropdown-content]:min-w-[219px] [&>.dropdown-menu>.dropdown-content]:max-h-[400px]':
          hasSearch,
      },
      '[&>.dropdown-menu>.dropdown-content]:bg-white-grey [&>.dropdown-menu>.dropdown-content]:overflow-auto [&>.dropdown-menu>.dropdown-content]:shadow-drop-shadow [&>.dropdown-menu>.dropdown-content]:min-w-full [&>.dropdown-menu>.dropdown-content]:w-auto [&>.dropdown-menu>.dropdown-content>.dropdown-item]:p-[0px]',
    ]"
    :position="dropdownPosition"
    :maxHeight="maxHeight"
    :scrollable="scrollable"
  >
    <template #trigger="{ active }">
      <slot name="dropdown-trigger" :active="active"></slot>
    </template>
    <b-dropdown-item
      v-for="(option, optionIndex) in options"
      :key="optionIndex"
      ariaRole="listitem"
      :class="['min-w-[124px]', getDropdownItemClass(option)]"
      :disabled="option.disabled || ifOptionIsDisabled(option)"
      @click="handleClickOption(optionIndex)"
    >
      <template #default>
        <slot name="dropdown-item" :option="option" :index="optionIndex">
          <BaseDropdownItem>
            {{ $t(option.label) }}
          </BaseDropdownItem>
        </slot>
      </template>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import BaseDropdownItem from '~/components/v2/Inputs/BaseDropdownItem.vue'

export default {
  components: {
    BaseDropdownItem,
  },
  props: {
    customOptions: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'default',
    },
    dropdownPosition: {
      type: String,
      default: 'is-bottom-left',
    },
    ifOptionIsDisabled: {
      type: Function,
      default: () => false,
    },
    isSelector: {
      type: Boolean,
      default: () => false,
    },
    onClickOption: {
      type: Function,
      default: () => ({}),
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: [Number, String],
      default: '200px',
    },
  },
  methods: {
    getDropdownItemClass(option) {
      if (option.value === this.value) {
        return 'bg-white'
      }
    },
    handleClickOption(index) {
      if (this.options[index]?.onClick) {
        this.options[index]?.onClick()
      } else {
        this.onClickOption(index)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep.dropdown {
  cursor: pointer;
  margin-left: 0;

  .button {
    width: 100%;
    display: flex;
    justify-content: space-between;

    span {
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .dropdown-trigger {
    .button-trigger {
      &__label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  &.is-disabled {
    cursor: not-allowed;
    opacity: 1;

    .button {
      background-color: #f7f7f7 !important;

      span {
        color: #999999;
      }
    }
  }

  &.width-160 {
    span {
      max-width: 160px;
    }
  }

  &.is-grey {
    color: #4c4c4c;
  }

  .dropdown-menu {
    min-width: 100%;

    .dropdown-content {
      &::-webkit-scrollbar {
        height: 8px;
        width: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #cccccc;
      }

      .dropdown-item {
        .search-box input {
          width: 100%;
        }
      }
    }
  }
}
</style>
